export const generatePayload = (profile) => {
  let payload = {};
  if (profile.size > 0) {
    const saSports = profile.get('sports');
    const keys = saSports.keySeq()
      .toArray();
    const sport = saSports.get(keys[0]);
    let primaryRole = '';
    if (sport.get('primary_offensive_position_pref') !== undefined) {
      if (sport.get('primary_offensive_position_pref') === 'QBDT' || sport.get('primary_offensive_position_pref') === 'QBPS') {
        primaryRole = 'QB';
      } else if (sport.get('primary_offensive_position_pref') === 'SR' || sport.get('primary_offensive_position_pref') === 'WR') {
        primaryRole = 'WR';
      } else if (sport.get('primary_offensive_position_pref') === 'RB' || sport.get('primary_offensive_position_pref') === 'FB' || sport.get('primary_offensive_position_pref') === 'SR' || sport.get('primary_offensive_position_pref') === 'HB') {
        primaryRole = 'RB';
      } else if (sport.get('primary_offensive_position_pref') === 'OG' || sport.get('primary_offensive_position_pref') === 'OT' || sport.get('primary_offensive_position_pref') === 'C') {
        primaryRole = 'OL';
      } else {
        primaryRole = sport.get('primary_offensive_position_pref');
      }
    } else if (sport.get('primary_defensive_position_pref') !== undefined) {
      if (sport.get('primary_defensive_position_pref') === 'ML' || sport.get('primary_defensive_position_pref') === 'OL') {
        primaryRole = 'LB';
      } else if (sport.get('primary_defensive_position_pref') === 'SS' || sport.get('primary_defensive_position_pref') === 'FS') {
        primaryRole = 'S';
      } else {
        primaryRole = sport.get('primary_defensive_position_pref');
      }
    }
    const academic = profile.get('academic');
    const combinedHeight = profile.get('height');
    const contactedCollegeLength = profile.get('sa_contactedlist').size;
    const heightIncm =
      (parseInt(combinedHeight.charAt(0)) * 12) + parseInt(combinedHeight.substr(2, 2)); // eslint-disable-line
    payload = {
      stats: {
        student_parameters: {
          squats: parseInt(sport.get('squats'), 10),
          bench: parseInt(sport.get('bench'), 10),
          forty: parseFloat(sport.get('t40'), 10),
          weight: parseInt(profile.get('weight'), 10),
          height: heightIncm,
        },
        role: primaryRole,
        consider_squats_and_bench: 'yes',
      },
      gpa: parseFloat(academic.get('gpa'), 10),
      act: parseInt(academic.get('act'), 10),
      from: 0,
      size: 50 + contactedCollegeLength,
    };
  }
  return payload;
};


export const getSubscription = (profile) => {
  let subscribed = false;
  if (profile && profile.size > 0) {
    let payment = '';
    if (profile.get('payment_info') !== undefined) {
      payment = profile.get('payment_info').last();
    }
    if (payment) {
      payment = payment.toJS();
      if (payment.last_date !== null) {
        const lastDate = new Date(payment.last_date);
        const currentDate = new Date();
        if (payment && payment.payment_status === true
          && lastDate.getTime() >= currentDate.getTime()) {
          subscribed = true;
        }
      } else if (payment.last_date === null) {
        if (payment && payment.payment_status === true) {
          subscribed = true;
        }
      }
    }
  }
  return subscribed;
};



// WEBPACK FOOTER //
// ./src/containers/Profile-view/functions.js